import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromTaxonomy from './taxonomy.reducer';

export const selectTaxonomyState = createFeatureSelector<fromTaxonomy.TaxonomyState>(
  fromTaxonomy.taxonomyFeatureKey
);
export const selectTaxonomies = createSelector(
  selectTaxonomyState,
  s1 => s1.taxonomies
);
export const selectFilteredTaxonomies = createSelector(
  selectTaxonomyState,
  s1 => s1.filteredTaxonomies
);
